import { render, staticRenderFns } from "./EditIcon.vue?vue&type=template&id=72c54fc8&scoped=true"
import script from "./EditIcon.vue?vue&type=script&lang=ts"
export * from "./EditIcon.vue?vue&type=script&lang=ts"
import style0 from "./EditIcon.vue?vue&type=style&index=0&id=72c54fc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c54fc8",
  null
  
)

export default component.exports